import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, withStyles, FormControl, TextField } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import PageTitle from '../../components/PageTitle/PageTitle';
import IconButton from '@material-ui/core/IconButton';
import * as Icons from '@material-ui/icons';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Loader from '../../components/Loader/LoaderView';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage, setSelectTenant } from '../../utils/common';
import DialogManageDevice from '../../components/Dialog/ManageDeviceView';
import CustomFooter from '../../components/Table/CustomFooter';
import SelectTenant from '../../components/Select/SelectTenant';

export class DevicesManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant: 0,
      openDialogManageDevice: {
        open: false,
        data: {
          id: null,
          tenantId: null,
          name: '',
          deviceId: '',
          deviceType: '',
          status: 'ACTIVATE_OFF',
        },
      },
    };
  }

  async componentDidMount() {
    const { filterOutStatus, offset, limit, search, sort, order, action, tenantIds } = this.props.device.toJS();
    if (action) {
      this.setState({
        tenant: tenantIds && tenantIds.length > 0 ? JSON.stringify(tenantIds) : 0,
      });
      await this.props.device.getDevices(filterOutStatus, offset, limit, search, sort, order, tenantIds);
      this.props.device.setAction('action', null);
    } else {
      const tenantIds = localStorage.getItem('select_tenant') ? [+localStorage.getItem('select_tenant')] : null;
      this.setState({
        tenant: tenantIds ? JSON.stringify(tenantIds) : 0,
      });
      this.props.device.resetData();
      this.props.device.setData('tenantIds', tenantIds);
      // await this.props.device.getDevices();
    }
  }

  deleteItem(id) {
    const { t } = this.props;
    Swal.fire({
      html: `<span class="swal-icon">
              <i
                class="fa fa-trash-o fa-3x fa-border"
                style="border: solid .08em #f27474; border-radius: 1.1em; margin-bottom: 35px; margin-top: 22px;">
              </i>
            </span>
            <br/>
            <h4>${t('delete_device')}`,
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('delete')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.device.deleteDevice(id);
          if (result.statusCode === 200) {
            Swal.fire({
              html: `<h4>${t('delete_success')}`,
              type: 'success',
            }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                const { filterOutStatus, offset, limit, search, sort, order, tenantIds } = this.props.device.toJS();
                await this.props.device.getDevices(filterOutStatus, offset, limit, search, sort, order, tenantIds);
              }
            });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        }
      }
      // else if (result.dismiss === Swal.DismissReason.cancel) {
      //   Swal.fire({ html: "<h4>Cancelled <br/>This device has not been delete. :)", type: "error" });
      // }
    });
  }

  activateStatus = async (id) => {
    const { t } = this.props;
    const { devices } = this.props.device.toJS();
    let data = devices.find((item) => item.id === id);
    if (data) {
      data.status = 'ACTIVATE_OFF';
    }
    try {
      const result = await this.props.device.activateDevice(data);
      if (result.statusCode === 200) {
        Swal.fire({
          html: `<h4>${t('activate_success')}`,
          type: 'success',
        }).then(async (resultSuccess) => {
          if (resultSuccess.value) {
            const { filterOutStatus, offset, limit, search, sort, order, tenantIds } = this.props.device.toJS();
            await this.props.device.getDevices(filterOutStatus, offset, limit, search, sort, order, tenantIds);
          } else {
            Swal.fire({
              html: `<h4>${t('failed_to_activate')}`,
              type: 'error',
            });
          }
        });
      }
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_activate')}`, type: 'error' });
      }
    }
  };

  createDevice() {
    const { classes, t } = this.props;
    return (
      <Button
        variant='outlined'
        color='primary'
        onClick={() => this.props.history.push('devices/create')}
        className={classes.button}
        id='createDeviceButton'
      >
        <Icons.Add />
        {t('create_device')}
      </Button>
    );
  }

  titleContent() {
    const { classes, t } = this.props;
    const { search } = this.props.device.toJS();
    return (
      <div className={classes.titleBar}>
        <SelectTenant handleChangeTenant={this.handleChangeTenant} tenant={this.state.tenant} />
        <Grid className={classes.search}>
          <FormControl variant='outlined' className={classes.formControl} fullWidth>
            <TextField
              variant='outlined'
              size='small'
              value={search || ''}
              name='search'
              id='search'
              className={classes.contentInput}
              placeholder={t('search')}
              onChange={(e) => this.handleChangeSearch(e)}
            ></TextField>
          </FormControl>
        </Grid>
      </div>
    );
  }

  handleChangeSearch = (event) => {
    const { value } = event.target;
    this.props.device.setData('offset', 0, false);
    this.props.device.setData('search', value);
  };

  validateTableRow = (data, expectedSize) => {
    return data && Array.isArray(data) && data.length === expectedSize;
  };

  handleOpenDialog = async (id) => {
    try {
      if (id) {
        const { devices } = this.props.device.toJS();
        const deviceData = devices.data.find((item) => item.id === id);
        if (deviceData) {
          await this.props.subGroup.getBasicSubgroupInfoByTenantId(deviceData.tenantId);
          await this.props.deviceType.getDeviceTypeList(0, 0);

          this.setState((prevState) => {
            prevState.openDialogManageDevice = {
              open: true,
              data: {
                ...prevState.openDialogManageDevice.data,
                id: deviceData.id,
                name: deviceData.name,
                deviceId: deviceData.serial,
                deviceType: deviceData.deviceVersion && deviceData.deviceVersion.id,
                tenantId: deviceData.tenantId,
                status: 'ACTIVATE_OFF',
              },
            };
            return prevState;
          });
        }
      }
    } catch (err) {
      console.log('error: ', err);
    }
  };

  handleCloseDialog = () => {
    this.setState({
      openDialogManageDevice: {
        open: false,
        data: {
          id: null,
          name: '',
        },
      },
    });
  };

  handleChangeTenant = async (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
    const tenantIds = JSON.parse(value);
    await this.props.device.setData('tenantIds', tenantIds);

    setSelectTenant(tenantIds);
  };

  handleChangeRowsPerPage = async (value) => {
    await this.props.device.setData('limit', value);
  };

  handlechangePage = async (value) => {
    const { limit } = this.props.device.toJS();
    await this.props.device.setData('offset', value * limit);
  };

  render() {
    const { classes, t } = this.props;
    const { devices, limit, search, sort, order, loading } = this.props.device.toJS();
    const page = devices.data ? devices.pagination.page - 1 : 0;
    const count = devices.data ? devices.pagination.count : 0;

    // let { subGroupsInfo } = this.props.subGroup.toJS();
    // subGroupsInfo = (subGroupsInfo || []).map((val) => {
    //   return {
    //     id: val.id,
    //     label: val.name,
    //   };
    // });

    const ARRAYSIZE = 8;
    const columns = [
      {
        name: 'id',
        label: `${t('id')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'id' && order ? order : 'none',
        },
      },
      {
        name: 'serial',
        label: `${t('serial')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'serial' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[1]}</div>;
          },
        },
      },
      {
        name: 'name',
        label: `${t('name')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'name' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[2]}</div>;
          },
        },
      },
      {
        name: 'deviceVersion.name',
        label: `${t('type')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'deviceVersion.name' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[3]}</div>;
          },
        },
      },
      {
        name: 'tenant.name',
        label: `${t('tenant')}`,
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth100}>{this.validateTableRow(row, ARRAYSIZE) && row[4]}</div>;
          },
        },
      },
      {
        name: 'assignTo',
        label: `${t('assign_to')}`,
        options: {
          filter: true,
          sort: false,
          // sortDirection: (sort === 'assignTo' && order) ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            const str = this.validateTableRow(row, ARRAYSIZE) ? row[5] : '';
            let result;
            if (str === 'null null') {
              result = ' ';
            } else {
              result = str;
            }
            return <div className={classes.columnWidth150}>{result}</div>;
          },
        },
      },
      {
        name: 'status',
        label: `${t('status')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'status' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            let result;
            if (row) {
              switch (this.validateTableRow(row, ARRAYSIZE) ? row[6] : '') {
                case 'ACTIVATE_ON':
                  result = (
                    <div
                      className={classes.columnWidth100}
                      id={`activeOnStatus-${row ? row[0] : ''}`}
                      style={{
                        backgroundColor: '#009D9A',
                        color: '#fff',
                        textAlign: 'center',
                      }}
                    >
                      ACTIVATE ON
                    </div>
                  );
                  break;
                case 'ACTIVATE_OFF':
                  result = (
                    <div
                      className={classes.columnWidth100}
                      id={`activeOffStatus-${row ? row[0] : ''}`}
                      style={{
                        backgroundColor: '#FEB341',
                        color: '#fff',
                        textAlign: 'center',
                      }}
                    >
                      ACTIVATE OFF
                    </div>
                  );
                  break;
                case 'DEACTIVATE':
                  result = (
                    <div
                      className={classes.columnWidth100}
                      id={`deactiveStatus-${row ? row[0] : ''}`}
                      style={{
                        backgroundColor: '#A9A9A9',
                        color: '#fff',
                        textAlign: 'center',
                      }}
                    >
                      DEACTIVATE
                    </div>
                  );
                  break;
                case 'DELETED':
                  result = (
                    <div
                      className={classes.columnWidth100}
                      id={`deletedStatus-${row ? row[0] : ''}`}
                      style={{
                        backgroundColor: '#F8B7AD',
                        color: '#fff',
                        textAlign: 'center',
                      }}
                    >
                      DELETED
                    </div>
                  );
                  break;
                case 'NEW':
                  result = (
                    <div
                      className={classes.columnWidth100}
                      id={`newStatus-${row ? row[0] : ''}`}
                      style={{
                        backgroundColor: '#EB5861',
                        color: '#fff',
                        textAlign: 'center',
                      }}
                    >
                      NEW
                    </div>
                  );
                  break;
                default:
                  break;
              }
            }
            return result;
          },
        },
      },
      {
        name: '',
        label: `${t('action')}`,
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div className={classes.actionBox}>
                {this.validateTableRow(row, ARRAYSIZE) && row[6] === 'NEW' && (
                  <div styles={{ display: 'flex' }}>
                    <IconButton title={t('view')} id='viewIcon'>
                      <Icons.FormatListBulleted color='disabled' />
                    </IconButton>
                    <IconButton title={t('edit')} id='editIcon'>
                      <Icons.Edit color='disabled' />
                    </IconButton>
                  </div>
                )}
                {this.validateTableRow(row, ARRAYSIZE) && row[6] !== 'NEW' && (
                  <div styles={{ display: 'flex' }}>
                    <Link to={`/app/devices/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/view`}>
                      <IconButton title={t('view')} id='viewIcon'>
                        <Icons.FormatListBulleted color='primary' />
                      </IconButton>
                    </Link>
                    <Link to={`/app/devices/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/edit`}>
                      <IconButton title={t('edit')} id='editIcon'>
                        <Icons.Edit color='primary' />
                      </IconButton>
                    </Link>
                  </div>
                )}
                <IconButton
                  title={t('delete')}
                  id='deleteIcon'
                  disabled={
                    this.validateTableRow(row, ARRAYSIZE) &&
                    (row[5] === 'null null' || row[5] === ' ' || row[5] === null)
                      ? false
                      : true
                  }
                  onClick={() => this.deleteItem(this.validateTableRow(row, ARRAYSIZE) ? row[0] : '')}
                >
                  <Icons.Delete
                    color={
                      this.validateTableRow(row, ARRAYSIZE) &&
                      (row[5] === 'null null' || row[5] === ' ' || row[5] === null)
                        ? 'primary'
                        : 'disabled'
                    }
                  />
                </IconButton>
                <IconButton
                  title='Activate off'
                  id='activateIcon'
                  style={{
                    display: this.validateTableRow(row, ARRAYSIZE) && row[6] === 'NEW' ? '' : 'none',
                  }}
                  onClick={() => this.handleOpenDialog(row ? row[0] : null)}
                >
                  <Icons.Add color='primary' />
                </IconButton>
              </div>
            );
          },
        },
      },
    ];

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <PageTitle title={t('all_devices')} button={this.createDevice()}>
          {this.titleContent()}
        </PageTitle>
        <Grid className={classes.mainContain} container spacing={32}>
          <Grid item xs={12}>
            <MUIDataTable
              data={devices.data}
              columns={columns}
              options={{
                count: devices.data ? devices.pagination.count : 0,
                page: devices.data ? devices.pagination.page - 1 : 0,
                searchText: search,
                serverSide: true,
                pagination: true,
                onTableChange: (action, tableState) => {
                  switch (action) {
                    case 'changePage':
                      this.props.device.setData('offset', tableState.page * tableState.rowsPerPage);
                      // this.props.user.setData('page',tableState.page);
                      break;
                    case 'changeRowsPerPage':
                      this.props.device.setData('limit', tableState.rowsPerPage);
                      break;
                    case 'search':
                      this.props.device.setData('offset', 0, false);
                      this.props.device.setData('search', tableState.searchText);
                      break;
                    case 'sort':
                      const sortList = tableState.announceText.split(' ');
                      this.props.device.setData('offset', 0, false);
                      this.props.device.setData('sort', sortList[4], false);
                      this.props.device.setData('order', sortList[6] === 'descending' ? 'desc' : 'asc');
                      break;
                    default:
                      break;
                  }
                },
                print: false,
                download: false,
                viewColumns: false,
                search: false,
                sortFilterList: true,
                sort: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                filter: false,
                filterType: 'dropdown',
                responsive: 'scrollFullHeight',
                rowsPerPageOptions: [10, 15, 50],
                rowsPerPage: limit,
                customFooter: (
                  // count,
                  // page,
                  rowsPerPage,
                  changeRowsPerPage,
                  changePage,
                  textLabels,
                ) => {
                  return (
                    <CustomFooter
                      count={count}
                      page={page}
                      rowsPerPage={limit}
                      changeRowsPerPage={this.handleChangeRowsPerPage}
                      changePage={this.handlechangePage}
                      textLabels={textLabels}
                      rowsPerPageOptions={[10, 15, 50]}
                    />
                  );
                },
                //   customSearch: (searchQuery, currentRow, columns) => {
                //     console.log('customSearch', searchQuery, currentRow, columns);
                //     return true;
                // },
                // customSearchRender: (searchText, handleSearch, hideSearch, options) => {
                //   console.log('customSearch', searchText, handleSearch, hideSearch, options);

                // }
              }}
            />
          </Grid>
        </Grid>

        {this.state.openDialogManageDevice.open && (
          <DialogManageDevice
            deviceData={this.state.openDialogManageDevice.data}
            open={this.state.openDialogManageDevice.open}
            handleCloseDialog={this.handleCloseDialog}
          />
        )}
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  actionBox: {
    minWidth: '200px',
    display: 'flex',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  columnWidth100: {
    maxWidth: '100px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  columnWidth150: {
    maxWidth: '150px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
    marginLeft: theme.spacing.unit * 2,
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  contentSelect: {
    display: 'flex',
    '& fieldset': {
      top: '2px',
    },
    '& svg': {
      top: 'calc(58% - 8px)',
    },
    '& select': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  iconSelect: {
    position: 'absolute',
    backgroundColor: 'transparent !important',
    display: 'flex',
    marginBottom: '10px',
    top: 'calc(58% - 3px)',
    right: 'calc(10% - 18px)',
  },
  button: {
    height: '38px',
    margin: theme.spacing.unit / 2,
  },
  fontTitle: {
    fontWeight: 'bold',
    fontSize: 16,
    marginTop: theme.spacing.unit,
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  search: {
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
  },
});

export const page = inject('device', 'deviceType', 'subGroup')(observer(DevicesManager));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
